<template>
  <v-app>
    <!-- Sticky Top App Bar -->
    <v-app-bar app dark>
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-toolbar-title>
        {{
          $vuetify.display.smAndUp ? 'School Management System' : 'SMS'
        }}</v-toolbar-title
      >
      <v-spacer />
      <!-- notification -->
      <v-menu
        v-model="notifMenu"
        location="bottom end"
        offset-y
        transition="scale-transition"
        :close-on-content-click="false"
      >
        <template #activator="{ props }">
          <v-badge
            :content="unreadCount > 99 ? '99+' : unreadCount"
            :model-value="hasUnread"
            color="blue"
            overlap
          >
            <v-btn icon v-bind="props">
              <v-icon :color="hasUnread ? 'white' : 'white'">
                {{ hasUnread ? 'mdi-bell-ring' : 'mdi-bell-outline' }}
              </v-icon>
            </v-btn>
          </v-badge>
        </template>

        <v-card
          width="380"
          max-height="650"
          class="overflow-y-auto rounded-xl elevation-8"
        >
          <!-- HEADER -->
          <v-card-title class="d-flex align-center px-5 py-4">
            <v-icon class="me-2" color="primary">mdi-bell-outline</v-icon>
            <span class="text-h6 font-weight-bold">Notifications</span>
          </v-card-title>

          <v-divider />

          <v-card-text class="pa-4">
            <div
              class="d-flex pa-2"
              v-if="$store.state.user.user.assignedModuleID != 22"
            >
              <v-row>
                <v-col cols="12" md="6">
                  <v-btn
                    block
                    :color="status === 'Lardo' ? 'blue' : 'grey'"
                    dark
                    @click="status = 'Lardo'"
                  >
                    Lardo
                  </v-btn>
                </v-col>

                <v-col cols="12" md="6">
                  <v-btn
                    block
                    :color="status === 'At-Risk' ? 'blue' : 'grey'"
                    dark
                    @click="status = 'At-Risk'"
                  >
                    At-Risk
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <!-- LARDO Notification -->
            <div
              v-if="lardoNotification.length"
              class="mb-6"
              v-show="status === 'Lardo'"
            >
              <div class="section-title">LARDO Notification</div>

              <v-card
                v-for="(req, i) in limitLardoAdviser"
                :key="'req-' + i"
                class="notif-card"
              >
                <div class="d-flex align-start">
                  <v-avatar size="42" class="me-3">
                    <v-icon>mdi-account</v-icon>
                  </v-avatar>

                  <div class="flex-grow-1">
                    <div class="text-body-2 font-weight-medium">
                      {{ req.student_name }}
                    </div>

                    <div class="text-caption text-grey-darken-1 mb-2">
                      {{ req.remarks }}
                    </div>
                    <div class="pt-3">
                      <strong> Decision Support Recommendation:</strong>
                    </div>
                    <div>{{ req.recommendation }}</div>
                    <v-btn
                      size="small"
                      color="primary"
                      variant="flat"
                      @click="openLardoNotification(req)"
                    >
                      View
                    </v-btn>
                  </div>

                  <v-badge v-if="!req.read" color="error" dot />
                </div>
              </v-card>
            </div>

            <!-- LARDO Faculty -->
            <div
              v-if="lardoNotificationForFaculty.length"
              class="mb-6"
              v-show="status === 'Lardo'"
            >
              <div class="section-title">LARDO Notification</div>

              <v-card
                v-for="(req, i) in limitLardoFaculty"
                :key="'req-' + i"
                class="notif-card"
              >
                <div class="d-flex align-start">
                  <v-avatar size="42" class="me-3">
                    <v-icon>mdi-account</v-icon>
                  </v-avatar>

                  <div class="flex-grow-1">
                    <div class="text-body-2 font-weight-medium">
                      {{ req.student_name }}
                    </div>

                    <div class="text-caption text-grey-darken-1 mb-2">
                      {{ req.remarks }}
                    </div>
                    <div class="pt-3">
                      <strong> Decision Support Recommendation:</strong>
                    </div>
                    <div>{{ req.recommendation }}</div>
                    <v-btn
                      size="small"
                      color="primary"
                      variant="flat"
                      @click="openLardoFacultyNotification(req)"
                    >
                      View
                    </v-btn>
                  </div>

                  <v-badge v-if="!req.read" color="error" dot />
                </div>
              </v-card>
            </div>

            <!-- At Risk Adviser -->
            <div
              v-if="atRiskNotification.length"
              class="mb-6"
              v-show="status === 'At-Risk'"
            >
              <div class="section-title">At-Risk Notification</div>

              <v-card
                v-for="(notif, index) in limitAtRiskAdviser"
                :key="'notif-' + index"
                class="notif-card clickable"
                @click="openAdviserNotification(notif)"
              >
                <div class="d-flex align-start">
                  <v-avatar size="42" class="me-3">
                    <v-icon>mdi-alert-circle-outline</v-icon>
                  </v-avatar>

                  <div class="flex-grow-1">
                    <div class="text-body-2 font-weight-medium">
                      {{ notif.student_name }}
                    </div>
                    <div class="text-caption text-grey-darken-1">
                      {{ notif.remarks }}
                    </div>
                  </div>

                  <v-badge v-if="!notif.read" color="error" dot />
                </div>
                <div class="pt-3">
                  <strong> Decision Support Recommendation:</strong>
                </div>
                <div>{{ notif.recommendation }}</div>
              </v-card>
            </div>

            <!-- Parent Notification -->
            <div v-if="parentNotification.length" class="mb-4">
              <!-- <div class="section-title">Parent Notification</div> -->

              <v-card
                v-for="(notif, index) in limitParentNotification"
                :key="'notif-' + index"
                class="notif-card clickable"
                @click="openParentNotification(notif)"
              >
                <div class="d-flex align-start">
                  <v-avatar size="42" class="me-3">
                    <v-icon>mdi-account-child-outline</v-icon>
                  </v-avatar>

                  <div class="flex-grow-1">
                    <div class="text-body-2 font-weight-medium">
                      {{ notif.student_name }}
                    </div>

                    <div class="text-caption text-grey-darken-1">
                      Grade: {{ notif.transmuted_grade }}
                    </div>

                    <div class="text-caption text-grey-darken-1">
                      Remarks: {{ notif.remarks }}
                    </div>
                  </div>

                  <v-badge v-if="!notif.read" color="error" dot />
                </div>
              </v-card>
            </div>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-4">
            <v-btn
              block
              rounded="lg"
              color="primary"
              variant="flat"
              @click="
                showAllNotifDialog = true;
                notifMenu = false;
              "
            >
              View All Notification
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

      <!-- Account-->
      <v-menu offset-y>
        <template #activator="{ props }">
          <v-chip
            v-bind="props"
            class="rounded-pill py-2 px-3 d-flex align-center"
            color="white"
            style="color: white"
          >
            <v-avatar size="32" class="me-2">
              <v-img
                :src="
                  !profImg ? require('@/assets/img/img_avatar.png') : profImg
                "
              />
            </v-avatar>
            <v-icon size="20" class="me-1" v-if="$vuetify.display.smAndDown">
              mdi-account-arrow-right
            </v-icon>
            <v-icon size="20">mdi-chevron-down</v-icon>
          </v-chip>
        </template>

        <v-card width="280" elevation="12" rounded="xl" class="overflow-hidden">
          <!-- HEADER -->
          <v-sheet color="pink" class="pa-4">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <v-avatar size="56" class="elevation-6">
                  <v-img
                    :src="
                      !profImg
                        ? require('@/assets/img/img_avatar.png')
                        : profImg
                    "
                    cover
                  />
                </v-avatar>
              </v-col>

              <v-col class="pl-3">
                <div class="text-subtitle-1 font-weight-bold text-white">
                  {{ $store.state.user.fname }}
                  {{ $store.state.user.lname.charAt(0).toUpperCase() }}.
                </div>
                <div class="text-caption text-white opacity-80">
                  {{ $store.state.user.usertype.description }} •
                  {{ getMyRole($store.state.user.user.user_roleID) }}
                </div>
              </v-col>

              <v-col cols="auto">
                <v-btn
                  icon
                  size="small"
                  variant="text"
                  color="white"
                  @click="menu = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-sheet>

          <!-- MENU -->
          <v-list density="comfortable" class="py-2">
            <v-list-item
              v-if="isValidated == 1"
              @click="assignedModuleDialog = true"
              rounded="lg"
              class="mx-2"
              prepend-icon="mdi-refresh-circle"
            >
              <v-list-item-title class="text-body-2">
                Change Role
              </v-list-item-title>
            </v-list-item>

            <v-divider class="my-2" v-if="isValidated == 1" />

            <v-list-item
              @click="logoutDialog = true"
              rounded="lg"
              class="mx-2 text-error"
              prepend-icon="mdi-logout"
            >
              <v-list-item-title class="text-body-2 font-weight-medium">
                Sign Out
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>

    <!-- Sticky Sidebar Drawer -->
    <v-navigation-drawer
      app
      v-model="drawer"
      :temporary="$vuetify.display.smAndDown"
    >
      <v-list nav dense class="sidebar mt-2">
        <!-- <v-list-item>
          <v-avatar>
            <v-img :src="profImg" width="60" />
          </v-avatar>
          <v-list-item-title class="text-uppercase">
            {{ $store.state.user.fname }} {{ $store.state.user.lname }}
          </v-list-item-title>
        </v-list-item> 
        <v-divider />-->
        <template v-for="(link, i) in links" :key="i">
          <v-list-item
            v-if="!link.subLink"
            :to="`/${userType}${link.route}`"
            router
            :exact="true"
            density="compact"
          >
            <div class="d-flex justify-left align-center">
              <v-icon start>{{ link.icon }}</v-icon>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </div>
          </v-list-item>

          <v-list-group v-else v-model="openGroups[i]">
            <template #activator="{ props }">
              <v-list-item v-bind="props" density="compact">
                <div class="d-flex justify-left align-center">
                  <v-icon start>{{ link.icon }}</v-icon>
                  <v-list-item-title>{{ link.title }}</v-list-item-title>
                </div>
              </v-list-item>
            </template>

            <v-list-item
              v-for="sublink in link.subLink"
              :key="sublink.title"
              :to="`/${userType}${sublink.route}`"
              router
              class="rounded my-1"
            >
              <v-list-item-title>{{ sublink.title }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- Scrollable Main Content -->
    <v-main class="scrollable-main bg-grey-lighten-4">
      <v-container fluid class="pa-6">
        <v-card rounded="xl" elevation="1">
          <!-- Header -->
          <v-card-title
            class="d-flex align-center justify-space-between"
            v-if="$route.meta.title != 'My Profile'"
          >
            <v-row>
              <v-col cols="12" md="6">
                <div class="text-h6 font-weight-bold">
                  {{ $route.meta.title }}
                </div>
                <!-- <div class="text-caption text-grey">Academic overview</div> --></v-col
              >
              <v-col
                cols="12"
                md="6"
                :class="
                  $vuetify.display.smAndDown
                    ? 'd-flex justify-center align-center'
                    : 'd-flex justify-end'
                "
              >
                <!--:disabled="userModule == 22"-->
                <v-autocomplete
                  v-model="selectedFilter"
                  label="School Year"
                  item-title="school_year"
                  item-value="id"
                  :items="filterYears"
                  density="compact"
                  variant="outlined"
                  hide-details
                  style="max-width: 220px"
                  @update:modelValue="changeFilter"
              /></v-col>
            </v-row>
          </v-card-title>

          <v-divider />

          <!-- Content -->
          <v-card-text class="pa-6">
            <router-view @reloadProfile="loadImg" />
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
    <!-- Notification Dialog -->
    <v-dialog v-model="showAllNotifDialog" scrollable max-width="650">
      <v-card class="rounded-xl elevation-10">
        <!-- HEADER -->
        <v-card-title class="d-flex align-center px-6 py-4">
          <v-icon class="me-2" color="primary"> mdi-bell-outline </v-icon>
          <span class="text-h6 font-weight-bold"> All Notifications </span>
          <v-spacer />
          <v-btn icon variant="text" @click="showAllNotifDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pa-6">
          <div
            class="d-flex pa-2"
            v-if="$store.state.user.user.assignedModuleID != 22"
          >
            <v-row>
              <v-col cols="12" md="6">
                <v-btn
                  block
                  :color="status === 'Lardo' ? 'blue' : 'grey'"
                  dark
                  @click="status = 'Lardo'"
                >
                  Lardo
                </v-btn>
              </v-col>

              <v-col cols="12" md="6">
                <v-btn
                  block
                  :color="status === 'At-Risk' ? 'blue' : 'grey'"
                  dark
                  @click="status = 'At-Risk'"
                >
                  At-Risk
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <!-- LARDO Notification -->
          <div
            v-if="lardoNotification.length"
            class="mb-8"
            v-show="status === 'Lardo'"
          >
            <div class="section-title">LARDO Notification</div>

            <v-card
              v-for="(req, i) in lardoNotification"
              :key="'req-' + i"
              class="notif-card"
            >
              <div class="d-flex align-start">
                <v-avatar size="44" class="me-3">
                  <v-icon>mdi-account</v-icon>
                </v-avatar>

                <div class="flex-grow-1">
                  <div class="text-body-2 font-weight-medium">
                    {{ req.student_name }}
                  </div>

                  <div class="text-caption text-grey-darken-1 mb-2">
                    {{ req.remarks }}
                  </div>

                  <div class="pt-3">
                    <strong> Decision Support Recommendation:</strong>
                  </div>
                  <div>{{ req.recommendation }}</div>
                  <v-btn
                    size="small"
                    color="primary"
                    variant="flat"
                    @click="openLardoNotification(req)"
                  >
                    View
                  </v-btn>
                </div>

                <v-badge v-if="!req.read" color="error" dot />
              </div>
            </v-card>
          </div>

          <!-- LARDO Faculty -->
          <div
            v-if="lardoNotificationForFaculty.length"
            class="mb-8"
            v-show="status === 'Lardo'"
          >
            <div class="section-title">LARDO Notification</div>

            <v-card
              v-for="(req, i) in lardoNotificationForFaculty"
              :key="'req-' + i"
              class="notif-card"
            >
              <div class="d-flex align-start">
                <v-avatar size="44" class="me-3">
                  <v-icon>mdi-account</v-icon>
                </v-avatar>

                <div class="flex-grow-1">
                  <div class="text-body-2 font-weight-medium">
                    {{ req.student_name }}
                  </div>

                  <div class="text-caption text-grey-darken-1 mb-2">
                    {{ req.remarks }}
                  </div>

                  <div class="pt-3">
                    <strong> Decision Support Recommendation:</strong>
                  </div>
                  <div>{{ req.recommendation }}</div>
                  <v-btn
                    size="small"
                    color="primary"
                    variant="flat"
                    @click="openLardoFacultyNotification(req)"
                  >
                    View
                  </v-btn>
                </div>

                <v-badge v-if="!req.read" color="error" dot />
              </div>
            </v-card>
          </div>

          <!-- At-Risk Adviser -->
          <div
            v-if="atRiskNotification.length"
            class="mb-8"
            v-show="status === 'At-Risk'"
          >
            <div class="section-title">At-Risk Notification</div>

            <v-card
              v-for="(notif, index) in atRiskNotification"
              :key="'notif-' + index"
              class="notif-card clickable"
              @click="openAdviserNotification(notif)"
            >
              <div class="d-flex align-start">
                <v-avatar size="44" class="me-3">
                  <v-icon>mdi-alert-circle-outline</v-icon>
                </v-avatar>

                <div class="flex-grow-1">
                  <div class="text-body-2 font-weight-medium">
                    {{ notif.student_name }}
                  </div>
                  <div class="text-caption text-grey-darken-1">
                    {{ notif.remarks }}
                  </div>
                </div>

                <v-badge v-if="!notif.read" color="error" dot />
              </div>
              <div class="pt-3">
                <strong> Decision Support Recommendation:</strong>
              </div>
              <div>{{ notif.recommendation }}</div>
            </v-card>
          </div>

          <!-- At-Risk Faculty -->
          <div v-if="atRiskNotificationForFaculty.length" class="mb-8">
            <div class="section-title">At-Risk Notification</div>

            <v-card
              v-for="(notif, index) in atRiskNotificationForFaculty"
              :key="'notif-' + index"
              class="notif-card clickable"
              @click="openFacultyNotification(notif)"
            >
              <div class="d-flex align-start">
                <v-avatar size="44" class="me-3">
                  <v-icon>mdi-alert-circle-outline</v-icon>
                </v-avatar>

                <div class="flex-grow-1">
                  <div class="text-body-2 font-weight-medium">
                    {{ notif.student_name }}
                  </div>
                  <div class="text-caption text-grey-darken-1">
                    {{ notif.remarks }}
                  </div>
                </div>

                <v-badge v-if="!notif.read" color="error" dot />
              </div>
              <div class="pt-3">
                <strong> Decision Support Recommendation:</strong>
              </div>
              <div>{{ notif.recommendation }}</div>
            </v-card>
          </div>

          <!-- Parent Notification -->
          <div v-if="parentNotification.length" class="mb-4">
            <!-- <div class="section-title">Parent Notification</div> -->

            <v-card
              v-for="(notif, index) in parentNotification"
              :key="'notif-' + index"
              class="notif-card clickable"
              @click="openParentNotification(notif)"
            >
              <div class="d-flex align-start">
                <v-avatar size="44" class="me-3">
                  <v-icon>mdi-account-child-outline</v-icon>
                </v-avatar>

                <div class="flex-grow-1">
                  <div class="text-body-2 font-weight-medium">
                    {{ notif.student_name }}
                  </div>

                  <div class="text-caption text-grey-darken-1">
                    Final Grade: {{ notif.transmuted_grade }}
                  </div>

                  <div class="text-caption text-grey-darken-1">
                    Remarks: {{ notif.remarks }}
                  </div>
                </div>

                <v-badge v-if="!notif.read" color="error" dot />
              </div>
            </v-card>
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            color="primary"
            variant="flat"
            rounded="lg"
            @click="showAllNotifDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Logout Dialog-->
    <v-dialog v-model="logoutDialog" max-width="420" persistent>
      <v-card class="rounded-lg">
        <!-- Header -->
        <v-card-title class="headline d-flex align-center">
          <!-- <v-icon color="red" class="mr-2">mdi-logout</v-icon> -->
          Confirm Logout
        </v-card-title>

        <v-divider></v-divider>

        <!-- Content -->
        <v-card-text class="text-center py-6">
          <p class="mb-2">Are you sure you want to log out?</p>
          <span class="grey--text text--darken-1">
            You will need to log in again to continue.
          </span>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Actions -->
        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>

          <v-btn color="grey" variant="outlined" @click="logoutDialog = false">
            Cancel
          </v-btn>

          <v-btn color="red" variant="flat" @click="logout()"> Logout </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Change Assign Module Dialog-->
    <v-dialog v-model="assignedModuleDialog" max-width="380" persistent>
      <v-card class="rounded-xl">
        <!-- Header -->
        <v-card-title class="text-h6 font-weight-medium px-6 py-4">
          Change Role
        </v-card-title>

        <v-divider />

        <!-- Content -->
        <v-card-text class="px-4 py-4">
          <v-row dense>
            <v-col
              cols="12"
              v-for="(item, index) in assigneAccessModulesList"
              :key="item.id"
            >
              <v-card
                class="role-card d-flex align-center justify-space-between px-4 py-3"
                :class="{ active: selectedModuleId === item.id }"
                elevation="0"
                border
                clickable
                ripple
                @click="selectButton(index, item)"
              >
                <span class="text-body-1">
                  {{ item.description }}
                </span>
                <v-icon v-if="selectedModuleId === item.id" color="#ff82e0">
                  mdi-check-circle
                </v-icon>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <!-- Actions -->
        <v-card-actions class="px-6 py-4">
          <v-btn
            variant="outlined"
            color="red"
            @click="assignedModuleDialog = false"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            color="pink"
            :loading="isLoading"
            variant="flat"
            :disabled="selectedModuleId === null"
            @click="confirmChangeRole"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </v-app>
</template>

<script>
export default {
  name: 'NavbarPage',
  data() {
    return {
      drawer: true,
      status: 'Lardo',
      notifMenu: false,
      logoutDialog: false,
      assignedModuleDialog: false,
      selectedModuleId: null,
      selected: [],
      selectedIndex: null,
      isLoading: false,
      selectedDate: new Date().toISOString().substr(0, 10),
      menu: [
        {
          title: 'Dashboard',
          icon: 'mdi-view-dashboard',
          active: true,
          items: ['Dashboard 1', 'Dashboard 2'],
        },
        {
          title: 'Apps',
          icon: 'mdi-apps',
          active: false,
          items: ['Chat', 'Calendar'],
        },
        {
          title: 'UI Elements',
          icon: 'mdi-palette',
          active: false,
          items: ['Buttons', 'Avatars'],
        },
      ],
      fadeAwayMessage: {
        show: false,
        type: 'success',
        header: 'Successfully Added!',
        message: '',
        top: 10,
      },
      mini: false,
      profImg: null,
      mobile: false,
      userRoleList: [],
      links: [],
      userID: null,
      userType: null,
      openGroups: [],
      notif_cnt: 0,
      showAllNotifDialog: false,
      interval: null,
      loading: false,
      options: [],
      activeGroup: null,
      schooYearList: [],
      newRoleData: null,
      selectedFilter: null,
      filterYears: [],
      userModule: null,
      notifTab: 0,
      isValidated: null,
      // unreadCount: 5,
      // hasUnread: true,
      lardoNotificationForFaculty: [],
      assigneAccessModulesList: [],
      lardoNotification: [
        // {
        //   name: "Jovelyn Billote Autintico",
        //   // avatar: "https://cdn.vuetifyjs.com/images/john.jpg",
        //   average: 65,
        //   read: false,
        // },
        // {
        //   name: "Florence Perucho",
        //   // avatar: "https://cdn.vuetifyjs.com/images/john.jpg",
        //   average: 69,
        //   read: false,
        // },
      ],
      atRiskNotificationForFaculty: [],
      atRiskNotification: [
        // {
        //   name: "Jovelyn Billote Autintico",
        //   // avatar: "https://cdn.vuetifyjs.com/images/john.jpg",
        //   read: false,
        // },
        // {
        //   name: "Florence Perucho",
        //   // avatar: "https://cdn.vuetifyjs.com/images/john.jpg",
        //   read: false,
        // },
      ],
      parentNotification: [],
    };
  },

  computed: {
    unreadCount() {
      const allNotifications = [
        ...this.lardoNotification,
        ...this.lardoNotificationForFaculty,
        ...this.atRiskNotification,
        ...this.atRiskNotificationForFaculty,
        ...this.parentNotification,
      ];
      return allNotifications.filter((n) => !n.read).length;
    },
    hasUnread() {
      return this.unreadCount > 0;
    },
    limitLardoAdviser() {
      return this.lardoNotification.slice(0, 5); // Returns the first 5 items
    },
    limitLardoFaculty() {
      return this.lardoNotificationForFaculty.slice(0, 5); // Returns the first 5 items
    },
    limitAtRiskFaculty() {
      return this.atRiskNotificationForFaculty.slice(0, 5); // Returns the first 5 items
    },
    limitAtRiskAdviser() {
      return this.atRiskNotification.slice(0, 5); // Returns the first 5 items
    },
    limitParentNotification() {
      return this.parentNotification.slice(0, 5); // Returns the first 5 items
    },
  },
  watch: {
    reloadImg() {
      this.loadImg();
    },
    assignedModuleDialog(val) {
      if (val) {
        this.setInitialSelectedRole();
      }
    },
  },
  mounted() {
    this.userId = this.$store.state.user.id;
    this.userModule = this.$store.state.user.user.assignedModuleID;
    this.isValidated = this.$store.state.user.user.isValidated;
    // console.log(this.$store.state.user.user.isValidated);
    this.loadYearForFilter();
    this.getLardoNotification();
    this.getLardoNotificationForFaculty();
    this.getAtRiskNotification();
    this.getAtRiskNotificationForFaculty();
    this.getParentNotification();
    this.getAccessControlAssignedModules();

    if (this.$vuetify.display.xs) {
      this.drawer = false;
      this.mini = false;
    }
  },
  methods: {
    setInitialSelectedRole() {
      this.assigneAccessModulesList = this.assigneAccessModulesList.map(
        (item) => ({
          ...item,
          id: Array.isArray(item.id) ? Number(item.id[0]) : Number(item.id),
        }),
      );
      console.table(this.assigneAccessModulesList);

      // this.selectedModuleId = Number(
      //   this.$store.state.user.user.assignedModuleID,
      // );

      this.newRoleData = this.assigneAccessModulesList.find(
        (item) => item.id === this.selectedModuleId,
      );
    },
    selectButton(index, item) {
      this.selectedModuleId = item.id;
      this.newRoleData = item;
      this.selectedIndex = index;
    },
    loadYearForFilter() {
      this.axiosCall('/enroll-student/getSchoolYear', 'GET').then((res) => {
        if (res) {
          this.selectedFilter = res.data[0].id;
          const activeYear = res.data.find((item) => item.status === 1);
          if (activeYear) {
            this.selectedFilter = activeYear.id;
          }
          this.$store.commit('setFilterSelected', this.selectedFilter);
          let data = res.data;
          this.filterYears = data;
        }
      });
    },
    changeFilter(newValue) {
      // this.$store.commit("setFilterSelected", this.selectedFilter);
      this.$store.commit('setFilterSelected', newValue);
      // let filter = this.$store.getters.getFilterSelected;
      // console.log(filter);
      // alert(filter);
    },

    openParentNotification(notif) {
      this.notifMenu = false;
      notif.read = true;
      this.showAllNotifDialog = false;
      if (notif.route) {
        this.axiosCall('/notification/' + notif.id, 'PATCH', { read: 1 }).then(
          (res) => {
            console.log(res);
            if (notif.route) {
              // this.$router.push(notif.route);
              this.$router.push('/' + this.userType + notif.route);
            }
          },
        );

        // this.$router.push(req.route);
      }
    },
    openAdviserNotification(notif) {
      notif.read = true;
      this.notifMenu = false;
      this.showAllNotifDialog = false;
      if (notif.route) {
        this.axiosCall(
          '/notification/updateAtRiskAdviser/' + notif.id,
          'PATCH',
          { read: 1 },
        ).then((res) => {
          console.log(res);
          if (notif.route) {
            // this.$router.push(notif.route);
            this.$router.push('/' + this.userType + notif.route);
          }
        });

        // this.$router.push(req.route);
      }
    },

    openFacultyNotification(notif) {
      notif.read = true;
      this.notifMenu = false;
      this.showAllNotifDialog = false;
      if (notif.route) {
        this.axiosCall(
          '/notification/updateAtRiskFaculty/' + notif.id,
          'PATCH',
          { read: 1 },
        ).then((res) => {
          console.log(res);
          if (notif.route) {
            // this.$router.push(notif.route);
            this.$router.push('/' + this.userType + notif.route);
          }
        });

        // this.$router.push(req.route);
      }
    },

    openLardoNotification(notif) {
      notif.read = true;
      this.notifMenu = false;
      this.showAllNotifDialog = false;
      if (notif.route) {
        this.axiosCall(
          '/notification/updateLardoAdviser/' + notif.id,
          'PATCH',
          { read: 1 },
        ).then((res) => {
          console.log(res);
          if (notif.route) {
            // this.$router.push(notif.route);
            this.$router.push('/' + this.userType + notif.route);
          }
        });

        // this.$router.push(req.route);
      }
    },
    openLardoFacultyNotification(notif) {
      notif.read = true;
      this.notifMenu = false;
      this.showAllNotifDialog = false;
      if (notif.route) {
        this.axiosCall(
          '/notification/updateLardoFaculty/' + notif.id,
          'PATCH',
          { read: 1 },
        ).then((res) => {
          console.log(res);
          if (notif.route) {
            // this.$router.push(notif.route);
            this.$router.push('/' + this.userType + notif.route);
          }
        });

        // this.$router.push(req.route);
      }
    },

    getMyRole(id) {
      const match = this.userRoleList.find(
        (r) => parseInt(r.id) === parseInt(id),
      );
      return match ? match.description : '';
    },
    openMobileNav() {
      this.drawer = true;
    },
    loadImg() {
      this.axiosCall('/user-details/getUserProfileImg', 'GET').then((res) => {
        this.profImg =
          process.env.VUE_APP_SERVER +
          '/user-details/getProfileImg/' +
          res.data.profile_img;
      });
    },
    toProfile() {
      const userType =
        this.$store.state.user.usertype.description.toLowerCase();
      const roleID = this.$store.state.user.user.user_roleID;
      const path =
        roleID === 5 ? '/superadmin/profile' : `/${userType}/profile`;
      this.$router.push(path);
    },
    getCurrentDate() {
      const cur_date = new Date();
      const month = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const day = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ];
      return `${day[cur_date.getDay()]}, ${
        month[cur_date.getMonth()]
      } ${cur_date.getDate()}; ${this.formatAMPM(cur_date)}`;
    },
    formatAMPM(date) {
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12 || 12;
      return `${hours}:${minutes} ${ampm}`;
    },
    closeNav() {
      this.drawer = false;
      this.$emit('closeNav');
    },
    loadMenu(userType, userRole) {
      this.openGroups = this.links.map((link) => !!link.subLink && false);
      this.axiosCall('/assigned-modules/getMyAssignedModules/my', 'GET').then(
        (resp) => {
          this.selectedModuleId = resp.data.id;
          // console.log("getMyAssignedModules", resp.data.id);
          this.links = JSON.parse(resp.data.assign_mods);
          switch (userType) {
            case 1:
              this.userType = 'admin';
              break;
            case 2:
              this.userType = userRole === 4 ? 'superadmin' : 'employee';
              break;
            case 3:
              this.userType = 'parent';
              break;
            case 4:
              this.userType = 'teacher';
              break;
          }
        },
      );
    },

    getLardoNotification() {
      this.axiosCall(
        '/notification/getLardoStudent/' + this.userId,
        'GET',
      ).then((res) => {
        console.log('Lardo', res.data);
        if (this.userModule == 21) {
          this.lardoNotification = res.data;
        }
      });
    },

    getLardoNotificationForFaculty() {
      this.axiosCall(
        '/notification/getLardoStudentForFaculty/' + this.userId,
        'GET',
      ).then((res) => {
        console.log('Lardo', res.data);
        if (this.userModule != 21) {
          this.lardoNotificationForFaculty = res.data;
        }
      });
    },

    getAtRiskNotification() {
      this.axiosCall(
        '/notification/getAtRiskStudent/' + this.userId,
        'GET',
      ).then((res) => {
        console.log('At-Risk', res.data);
        if (this.userModule == 21) {
          this.atRiskNotification = res.data;
        }
      });
    },

    getAtRiskNotificationForFaculty() {
      this.axiosCall(
        '/notification/getAtRiskStudentForFaculty/' + this.userId,
        'GET',
      ).then((res) => {
        console.log('At-Risk', res.data);
        if (this.userModule != 21) {
          this.atRiskNotificationForFaculty = res.data;
        }
      });
    },
    getParentNotification() {
      this.axiosCall(
        '/notification/getParentNotification/' + this.userId,
        'GET',
      ).then((res) => {
        console.log('Parent', res.data);
        this.parentNotification = res.data;
      });
    },
    getAccessControlAssignedModules() {
      this.axiosCall('/assigned-modules/getSpecificModules', 'GET').then(
        (res) => {
          // console.log("AssignedM", res.data);
          let data = res.data;
          this.assigneAccessModulesList = data;
        },
      );
    },
    confirmChangeRole() {
      // console.log(
      //   "confirmChangeRole()",
      //   this.newRoleData.id,
      //   this.$store.state.user.user.id,
      // );
      this.isLoading = true;
      let userID = this.$store.state.user.user.id;
      let data = {
        assignedModuleID: this.newRoleData.id,
      };
      this.axiosCall(
        '/auth/changeAssignedModule/Role/' + userID,
        'POST',
        data,
      ).then((res) => {
        if (res.data.status == 200) {
          // this.$store.commit('SET_ASSIGNED_MODULE', this.newRoleData.id);
          // this.$store.dispatch('updateAssignedModule', this.newRoleData.id);
          // this.logout();
          this.isLoading = false;
          location.reload();
        } else if (res.data.status == 400) {
          this.isLoading = false;
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = 'error';
          this.fadeAwayMessage.header = 'System Message';
        }
      });
    },
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  created() {
    const userType = this.$store.state.user.user.usertypeID;
    const userRole = this.$store.state.user.user.user_roleID;
    this.loadMenu(userType, userRole);
    this.interval = setInterval(() => {
      this.getLardoNotification();
      this.getLardoNotificationForFaculty();
      this.getAtRiskNotification();
      this.getAtRiskNotificationForFaculty();
      this.getParentNotification();
    }, 180000);
  },
};
</script>

<style scoped>
/* Scrollable area */
.scrollable-main {
  height: calc(100vh - 64px);
  overflow-y: auto;
  background-color: #f3f4f6; /* Soft gray */
}

/* Sidebar active link */
.sidebar .v-list-item--active {
  background-color: #dc0b70 !important;
  color: #ffffff !important;
}

/* Sidebar sublink active */
.sidebar .v-list-group .v-list-item--active {
  background-color: #dc0b70 !important; /* Lighter teal */
  color: #ffffff !important;
  border-radius: 5px;
}

/* Hover states */
.sidebar .v-list-item:hover {
  background-color: rgba(13, 148, 136, 0.1) !important;
}
.sidebar .v-list-item--active:hover {
  color: #dc0b70 !important;
}

/* App bar */
.v-app-bar {
  background-color: #dc0b70 !important;
  color: white !important;
}

/* Notification badge color */
.v-badge .v-badge__badge {
  background-color: #f97316 !important; /* Orange */
}

/* Primary button color override */
/* .v-btn {
  background-color: #dc700b !important;
  color: white !important;
} */

.close {
  background-color: #ffffff !important;
  color: rgb(0, 0, 0) !important;
}

.role-card {
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.role-card:hover {
  /* background-color: rgba(0, 0, 0, 0.03); */
  background-color: #ff82e0;
}

.role-card.active {
  border: 2px solid #ff82e0;
  background-color: rgba(25, 118, 210, 0.08);
}
.v-list-item {
  transition: background-color 0.2s ease, transform 0.15s ease;
}

.v-list-item:hover {
  transform: translateX(2px);
}
.section-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 12px;
  color: #555;
}

.notif-card {
  padding: 14px;
  margin-bottom: 12px;
  border-radius: 14px;
  transition: all 0.2s ease;
  cursor: default;
}

.notif-card.clickable {
  cursor: pointer;
}

.notif-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}
.section-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 14px;
  color: #555;
}

.notif-card {
  padding: 16px;
  margin-bottom: 14px;
  border-radius: 14px;
  transition: all 0.2s ease;
  cursor: default;
}

.notif-card.clickable {
  cursor: pointer;
}

.notif-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}
</style>
